module.exports = __webpack_public_path__ + "static/NavLogoWhite-3e3224980587e6f219b19e70692315b2.png";